var SENTRY_RELEASE;SENTRY_RELEASE={name: "Clubswap", version: "1.0.0"};